import { motion } from 'framer-motion'
import { fadeRise } from './motion'

interface Props {
  /** An emoji, sized up. Cheaper than an illustration and it translates. */
  icon: string
  title: string
  description?: string
  action?: React.ReactNode
}

/**
 * What a screen shows when there is genuinely nothing to show.
 *
 * Generalises the one good empty state the app already had — the dashed 🏆
 * card on Competitions — so the other eight stop being a grey sentence.
 */
export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <motion.div
      variants={fadeRise}
      className="flex flex-col items-center gap-2 rounded-lg border border-dashed border-[var(--gym-line)] px-6 py-12 text-center"
    >
      <span aria-hidden className="text-3xl opacity-80">
        {icon}
      </span>
      <p className="text-sm font-semibold text-foreground/70">{title}</p>
      {description && (
        <p className="max-w-xs text-xs leading-relaxed text-foreground/45">{description}</p>
      )}
      {action && <div className="mt-3">{action}</div>}
    </motion.div>
  )
}
